export default __webpack_public_path__ + "static/media/_ill_apha.62c5c6ae.svg";